import React, { memo } from "react";
import Container from "../components/Container";

const PrivacyPolicies = memo(() => {
  return (
    <Container>
      <div className=" space-y-3 py-6">
        <p className="text-lg">
          At JustSaveVideos, we are committed to protecting your privacy and
          safeguarding your personal information. This privacy policy outlines
          how we handle and treat personal data related to your use of our
          website and the services offered through it ("the Service"). By using
          our Service, you agree to the terms and conditions of this policy.
        </p>
        <p className="text-lg">
          The Service is intended for use by adults who are over 18 years of age
          or the age of majority in their jurisdiction, whichever is greater.
          Users below this age are strictly prohibited from accessing or using
          the Service. We do not knowingly seek or collect personal information
          from individuals who have not attained the required age.
        </p>
        <h2 className=" font-bold text-xl">Information Collected</h2>
        <ol className="text-lg list-disc list-inside text-justify pl-6 space-y-2">
          <li>
            <span className=" font-semibold">Use of the Service:</span> When you
            access the Service, utilize the search function, convert or download
            files, certain non-personal information may be recorded for log file
            information, aggregated traffic information, and to prevent any
            potential misuse or misappropriation of information and/or content.
            This information may include your IP address, country of origin, and
            other details about your computer or device (such as web requests,
            browser type, browser language, referring URL, operating system, and
            date and time of requests).
          </li>
          <li>
            <span className=" font-semibold"> Usage Information:</span> We may
            collect information about your usage of the Service, including
            search terms, the content you access and download, and other related
            statistics.
          </li>
          <li>
            <span className=" font-semibold">Uploaded Content:</span> Any
            content that you upload, access, or transmit through the Service may
            be collected by us for the purpose of providing the Service to you.
          </li>
          <li>
            <span className=" font-semibold">Correspondence:</span> We may
            retain records of any correspondence between you and us to ensure
            effective communication and to address any inquiries or concerns.
          </li>
          <li>
            <span className=" font-semibold">Cookies:</span> To enhance your
            browsing experience and uniquely identify your browser session, we
            may send cookies to your computer when you use the Service. These
            cookies may be either session cookies or persistent cookies.
          </li>
        </ol>
        <h2 className=" font-bold text-xl">Data Usage</h2>
        <p className="text-lg">
          We use the collected information for the following purposes:
        </p>
        <ol className="text-lg list-disc list-inside text-justify pl-6 space-y-2">
          <li>
            To provide and improve the Service, including troubleshooting issues
            and enhancing functionality.
          </li>
          <li>
            To analyze usage patterns and trends, and to generate statistical
            information to further improve the Service.
          </li>
          <li>
            To respond to your inquiries, comments, or concerns, and to provide
            you with customer support.
          </li>
          <li>To enforce our Terms of Use and other policies.</li>
        </ol>
        <p className="text-lg">
          We do not sell, trade, or rent any information to third parties
          without your consent, except in the following circumstances:
        </p>
        <p className="text-lg">
          We utilize cookies, web beacons, and similar technologies to store
          information for future visits, eliminating the need for you to
          re-enter it. These technologies also enable us to provide personalized
          content and information, assess the effectiveness of the Service, and
          gather aggregated metrics like visitor numbers and page views
          (including monitoring visitors from affiliate sources). Additionally,
          they may facilitate targeted advertising based on factors such as your
          location and other relevant personal details.
        </p>
        <h2 className=" font-bold text-xl">Disclosures of Information</h2>
        <p className="text-lg">
          We may be obligated to disclose specific data to fulfill legal
          requirements or to enforce our Terms of Use and other agreements.
          Furthermore, we may disclose certain data to safeguard the rights,
          property, or safety of ourselves, our users, and others. This may
          involve providing information to external entities, such as law
          enforcement agencies or government authorities, to prevent or
          prosecute any unlawful activities, regardless of whether they are
          explicitly mentioned in the Terms of Use.
        </p>
        <p className="text-lg">
          If you upload, access, or transmit any material that is illegal or
          unauthorized through the Service, or if there are suspicions of such
          activities, we reserve the right to share all available information
          with relevant authorities, including copyright holders, without prior
          notification to you.
        </p>
        <h2 className=" font-bold text-xl">Miscellaneous</h2>
        <p className="text-lg">
          Although we employ reasonable physical, managerial, and technical
          measures to protect your information, it is important to note that the
          transmission of information over the internet is not entirely secure.
          Therefore, we cannot guarantee the absolute security of any
          information or content you transmit to us. Any transmission of
          information or content is undertaken at your own risk.
        </p>
      </div>
    </Container>
  );
});

export default PrivacyPolicies;
